import segment from '../../../../analytics/segment';

const ICON_ID = 'social-media-icons';
const ICON_ADJUSTED = 'group-icon';

const trackIconSizeResized = ({ blockId, blockVariationId, oldSize, newSize }) => {
  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.ICON_SIZE_RESIZED, {
    blockId,
    blockVariationId,
    oldSize,
    newSize,
    iconAdjusted: ICON_ADJUSTED,
    iconId: ICON_ID,
  });
};

export default trackIconSizeResized;
